<template>
  <div class="sidebar">
    <!-- Home -->
    <VTooltip>
      <template #activator="{ props }">
      <div class="project-circle-button" style="color: black" v-bind="props">
        <a href="/home">
        <span role="img" 
          class="mdi mdi-home" 
          aria-label="Home icon for accessibility" 
          style="font-size: 1.5em;" />
        </a>
      </div>
      </template>
      <span>Home</span>
    </VTooltip>
    
    <!-- CMS -->
    <VTooltip>
      <template #activator="{ props }">
      <div class="project-circle-button" style="color: black" v-bind="props">
        <a href="/cms">
        <span role="img" 
          class="mdi mdi-plus" 
          aria-label="Add icon for accessibility" 
          style="font-size: 1.5em;" />
        </a>
      </div>
      </template>
      <span>CMS</span>
    </VTooltip>

    <!-- Tutorial -->
    <VTooltip>
      <template #activator="{ props }">
      <div class="project-circle-button" style="color: black" v-bind="props">
        <a href="/tutorial" target="_blank">
        <span role="img" 
          class="mdi mdi-help-circle" 
          aria-label="Help icon for accessibility" 
          style="font-size: 1.5em;" />
        </a>
      </div>
      </template>
      <span>Tutorial</span>
    </VTooltip>
    
    <VDivider class="my-divider" />

    <!-- Lista de proyectos -->
    <div v-for="project in this.$store.state.projectsList" :key="project._id">
      <VTooltip>
        <template #activator="{ props }">
          <a :href="'/p/' + project._id + '/home'" style="width: 100%; height: 100%;" v-bind="props">
            <div class="project-circle-button" :style="{ color: 'black', backgroundImage: `url(${project.iconUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}">
            </div>
          </a>
        </template>

        <span>{{ project.name }}</span>
      </VTooltip>
    </div>
  </div>
</template>

<script>
import api from '@/api.js';
export default {
  name: "ProjectsListComponent",
  methods: {
    async getAllProjects() {
      const token = localStorage.getItem("token");
      try {
        const response = await api.get(
          `/api/project/get/findByUser`,
          { headers: {Authorization: `Bearer ${token}`}}
        );
        this.$store.commit('setProjectLists', response.data);
      } catch (error) {
        console.error(error);
      }
    },
  },
  async created() {
    await this.getAllProjects();
  },
};
</script>

<style scoped>
.sidebar {
  width: 80px;
  height: 100vh;
  overflow-y: auto;
  padding: 15px;
  background-color: #14B8A6;

  /* Alinear los proyectos verticalmente */
  display: flex;
  flex-direction: column;
  align-items: center;

  /* Ocultar la barra de desplazamiento para firefox */
  scrollbar-width: none;
}

.sidebar::-webkit-scrollbar {
  display: none;  /* Ocultar la barra de desplazamiento para chrome, safari y edge */
}

.project-circle-button {
  display: block;
  width: 55px;
  height: 55px;
  background-color: white;
  color: white;
  text-align: center;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s ease;
  border-radius: 50%;
  transition: 0.1s ease;
  margin-bottom: 10px;

  min-width: 55px; /* Mantener tamaño mínimo */
  min-height: 55px;
  aspect-ratio: 1 / 1; /* Mantiene proporción cuadrada */
}

.project-circle-button:hover{
  border-radius: 35%;
}

.project-circle-button span {
  color: black;
  font-size: 2em;
  line-height: 2em;
  vertical-align: middle;
  transition: 0.1s ease;
  height: 100%;
  width: 100%;
  /* background-color: red; */
}

a {
  /* Quitar estilo de enlace */
  text-decoration: none;
  color: white;
}

.custom-divider {
  border-color: red !important;
}

.my-divider {
  width: 50px; /* o 60px si quieres que ocupe todo el ancho */
  height: 2px;
  background-color: #999 !important;
  opacity: 50%;
  margin: 12px 0;
}

</style>
